// extracted by mini-css-extract-plugin
export default {"reportIframe":"styles_reportIframe__xcWYY"};